import React, { Fragment } from "react"
import { Link } from "react-router-dom"
import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { LazyImage } from "components"
import SideNavigationItems from "./SideNavigationItems"
import classes from "./SideNavigation.module.scss"

const SideNavigation = props => {
  const { openSidebar, setOpenSidebar } = props

  const i18n = useTranslation()[1]

  const { role, fullName } =
    useSelector(state => state.userAccountInfo)

  const { kitchenLogo, kitchenTitle } =
    useSelector(state => state.systemSettings)

  const isLtr = i18n.dir(i18n.language) === "ltr"

  if (!role) return null

  return (
    <Fragment>
      <div
        className={clsx(
          classes["scrollbar"],
          isLtr && classes["scrollbar-ltr"],
          openSidebar && classes["move"]
        )}
      >
        <div className={classes["logo"]}>
          <Link to="/">
            <LazyImage
              src={kitchenLogo}
              width="60px"
              quality={80}
              style={{ borderRadius: "15%" }}
              alt=""
            />
          </Link>

          <div className={classes["title"]}>
            {kitchenTitle}
          </div>

          <div className={classes["name"]}>
            {fullName}
          </div>
        </div>

        <SideNavigationItems
          setOpenSidebar={setOpenSidebar}
        />

        <div className={classes["footer"]}>
          Developed by{" "}
          <a
            href="https://faradidrasam.ir/"
            target="_blank"
            rel="noreferrer"
            className={classes["link"]}
          >
            Faradid
          </a>
        </div>
      </div>

      {
        openSidebar &&
        <div
          className={classes["overlayer"]}
          onClick={() => setOpenSidebar(false)}
        />
      }
    </Fragment>
  )
}

export default SideNavigation